<template>
  <svg
    aria-hidden="true"
    class="icon"
    :style="{ color: color || 'currentColor' }"
  >
    <use :xlink:href="`#icon-${name}`" />
  </svg>
</template>

<script setup lang="ts">
  interface Props {
    name: string;
    color?: string;
    size?: string | number;
  }

  const props = withDefaults(defineProps<Props>(), {
    color: '',
    size: '1em',
  });
</script>

<style scoped>
  .icon {
    width: v-bind('props.size');
    height: v-bind('props.size');
    vertical-align: -0.15em;
    fill: currentColor;
    overflow: hidden;
    display: inline-block;
  }
</style>
